<template>
  <div class="white_container reserved_container">
    <h4>{{lesson.title}}</h4>
    <h2>{{lesson.header}}</h2>
    <p>Lecție indisponibilă. Vă rugăm să supliniți contul pentru a continua nivelul</p>
    <button class="button" @click="toShop">
      <span>Supliniți contul</span>
    </button>
  </div>
</template>

<script>
  import Countdown from '../Countdown';
  import i18n from '@/i18n';
  export default {
    name: "NotPaid",
    components: {
      Countdown
    },
    props: {
      lesson: {
        type: Object,
        default: {}
      },
    },
    data: function () {
      return {
        isSoonLesson: -1,
      }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
      toShop() {
        this.$router.push({
          name:"shop",
          params:{
            locale:i18n.locale,
          }
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .button {
    padding: 0.75rem 2.5rem 1rem 2.5rem;
    margin-bottom: 2rem;
    margin-top: 6rem;
  }
  .timer {
    margin-top: 10.5rem;
  }

  .reserved_container{
    text-align: center;
    padding: 6rem 1.5rem 4rem;
    .start_container_text{
      margin-top: 2rem;
    }
  }
</style>
